module.exports = __webpack_public_path__ + "static/media/2.d99f4d51.jpg";